const VwFix = function (settings) {
	"use strict";

	const _self = this;
	const _settings = {
		open: false,
	};

	Object.assign(_settings, settings);

	function init() {
		const scrollbarWidth = window.innerWidth - document.body.clientWidth;

		document.documentElement.style.setProperty(
			"--scroll-width",
			`${scrollbarWidth}px`
		);

		return _self;
	}

	return init();
};

export { VwFix };
